import PropTypes from 'prop-types';
import React from 'react';
import useCountAnimation from './hooks/useCountAnimation';
import {
  MetricCard,
  MetricContent,
  MetricValue,
  MetricLabel,
  MetricChange,
  MetricIcon,
} from './StyledComponents';

const AnimatedMetric = ({
  value,
  label,
  changeText,
  isPositive = true,
  isCurrency = false,
  isPercentage = false,
  decimals = 0,
  _color,
  duration = 1500,
  icon,
}) => {
  const animatedValue = useCountAnimation(value, duration);

  const formatValue = (num) => {
    if (isCurrency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(num);
    }

    if (isPercentage) {
      return `${num.toFixed(decimals)}%`;
    }

    if (decimals > 0) {
      return num.toFixed(decimals);
    }

    return Math.floor(num).toLocaleString();
  };

  return (
    <MetricCard>
      <MetricContent>
        <MetricLabel>{label}</MetricLabel>
        <MetricValue>{formatValue(animatedValue)}</MetricValue>
        {changeText && (
          <MetricChange positive={isPositive}>
            <svg width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
              {isPositive ? (
                <path d="M7.247 4.86l-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
              ) : (
                <path d="M7.247 11.14l-4.796-5.481C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              )}
            </svg>
            <span>{changeText}</span>
          </MetricChange>
        )}
      </MetricContent>
      {icon && <MetricIcon>{icon}</MetricIcon>}
    </MetricCard>
  );
};

AnimatedMetric.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string.isRequired,
  changeText: PropTypes.string,
  isPositive: PropTypes.bool,
  isCurrency: PropTypes.bool,
  isPercentage: PropTypes.bool,
  decimals: PropTypes.number,
  color: PropTypes.string,
  duration: PropTypes.number,
  icon: PropTypes.node,
};

export default AnimatedMetric;
